import React from "react";

const Footer: React.FC = () => {
  return (
          <footer className="bg-dark text-white py-4 mt-4">
            <div className="container d-flex justify-content-between align-items-center flex-wrap text-center text-md-start">
              <a href="mailto:support@uplatz.com" className="text-white text-decoration-none">
                <i className="bi bi-envelope-fill"></i>
                &nbsp; support@uplatz.com
              </a>
              <span>&copy; 2025 Uplatz. All rights reserved.</span>
              <a href="tel:+447459302492" className="text-white text-decoration-none">
                <i className="bi bi-telephone-fill"></i>
                &nbsp; +44 7459 302492
              </a>
            </div>
          </footer>
  );
};

export default Footer;
